<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="add-cot-modal-header">
                Zerar Prorrogação
                <span class="material-icons-outlined add-cot-modal-header-close" @click="close">
                    close
                </span>
            </div>
            <div class="add-cot-modal-body">
                <div class="edit-tab-inputs-container">
                    <div>
                        <p class="products-page__datetime-title">
                            Deseja zerar a prorrogação da cotação
                            <span class="products-page__datetime-subtitle">
                                ID {{ selectedCot.cot_id }}
                            </span>
                            ?
                        </p>
                    </div>
                </div>
                <div class="edit-tab-buttons-container">
                    <StandardButton text="Cancelar" :action="close" />
                    <StandardButton text="Confirmar" :action="zeroProrrogation" />
                </div>
            </div>
        </div>
        <cc-loader-full v-if="isLoading" />
    </div>
</template>

<script>
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import ClientService from "@/services/v3/client.service.js";

export default {
    name: "AddCotModal",
    components: {
        StandardButton,
    },
    props: {
        close: {
            type: Function,
        },
        cot: {
            type: Object,
        },
    },
    data() {
        return {
            selectedCot: {
                cot_id: this.cot.id,
            },
            svc: new ClientService(),
            isLoading: false,
        };
    },
    methods: {
        async zeroProrrogation() {
            this.isLoading = true;
            try {
                await this.svc.zeroProrrogation(this.selectedCot.cot_id);
                this.$emit("prorrogation-zeroed");
                this.present_info("Prorrogação zerada com sucesso!");
                this.close();
            } catch (error) {
                console.error("Erro ao zerar prorrogação:", error);
                this.present_error("Erro ao zerar prorrogação");
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    overflow-y: auto;
    font-size: 1vw;
}

.modal-content-container {
    background-color: #fff;
    border-radius: 12px;
    width: 40vw;
}

.add-cot-modal-header {
    background: var(--primary-color);
    border-radius: 10px 10px 0px 0px;
    font-weight: 500;
    font-size: 2.3em;
    color: #ffffff;
    padding: 1vh 2vw;
    display: flex;
    justify-content: space-between;
}

.add-cot-modal-header-close {
    font-size: 1.4em;
    cursor: pointer;
}

.add-cot-modal-body {
    padding: 5vh 1vw;
}

.edit-tab-inputs-container {
    display: grid;
    justify-content: center;
    margin-top: 5vh;
    gap: 5vw;
}

.products-page__datetime-title {
    font-size: 1.4em;
    font-weight: 400;
    letter-spacing: 0.15px;
    color: #898989;
}

.products-page__datetime-subtitle {
    color: #232323;
}

.edit-tab-buttons-container {
    display: flex;
    justify-content: center;
    margin-top: 5vh;
    gap: 1vw;
}
</style>
